import React from 'react';
import { Constants } from '@bingads-webui-clientcenter/entity-utils';
import { GlobalViewTaxForm } from './global-viewtaxform';
import { ViewTaxFormPropTypes } from '../../shapes';

const { TaxCertLabel, CountryCode } = Constants;

export const NPTaxViewTaxForm = (props) => {
  const { i18n } = props;
  const taxCertLabel = i18n.getString(TaxCertLabel.TaxCertificate);

  return (
    <GlobalViewTaxForm
      {...props}
      taxCertLabel={taxCertLabel}
      countryCode={CountryCode.NP}
    />
  );
};

NPTaxViewTaxForm.propTypes = ViewTaxFormPropTypes;
